/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Mikhail Kokoulin
 * @version 1.0.0
 * @since 1.0.0
 */
import { createAction } from '../app/createAction';
import { FETCH_FAILURE, FETCH_SUCCESS, SET_REQUEST_PARAMS, START_POLLING, STOP_POLLING } from './pollingConstants';
import { IFetchSuccess, IPollingRequestParams, ISetRequestParams, IStartPolling, IStopPolling } from './pollingTypes';

/**
 * Action for start polling with some requests
 * @returns {IStartPolling}
 */
export const startPolling = (): IStartPolling => createAction(START_POLLING);

/**
 * Action for stop polling with some requests
 * @returns {IStartPolling}
 */
export const stopPolling = (): IStopPolling => createAction(STOP_POLLING);

/**
 * Action set request params for polling reducer
 * @param {IPollingRequestParams} payload
 * @returns {ISetRequestParams}
 */
export const setRequestParams = (payload: IPollingRequestParams): ISetRequestParams =>
    createAction(SET_REQUEST_PARAMS, payload);

/**
 * Action for success fetch data
 * @param payload
 * @returns {IFetchSuccess}
 */
export const fetchSuccess = (payload: unknown): IFetchSuccess => createAction(FETCH_SUCCESS, payload);

/**
 * Action for failure fetch data
 * @param {string} payload
 * @returns {IActionWithPayload<string, string>}
 */
export const fetchFailure = (payload: string) => createAction(FETCH_FAILURE, payload);

